import { SET_APPROVAL_POPUP, APPROVAL_POPUP } from './ContractPageFormConstants';

export default (state = { currentPopUpName: APPROVAL_POPUP}, action) => {
    switch (action.type) {
        case SET_APPROVAL_POPUP:
            return { ...state, currentPopUpName: action.payload };
        default:
            return state;
    }
};
